// extracted by mini-css-extract-plugin
module.exports = {"container":"Kambi__container--1yd","loadingContainer":"Kambi__loadingContainer--1TE"};